angular.module("ainapp")
    .controller("ticketsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {


            $scope.PageName = "Tickets";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Status = [];
            MainService.TicketStatusList().then(function (response) {
                if (response.data) {
                    $scope.Status = response.data;
                    var temp = {
                        Id: "",
                        Name: "All"
                    }
                    $scope.Status.push(temp);
                } else {
                    toastr.error("Error");
                }
                $scope.load = false;
            }, function (err) {
                toastr.error("Network Error");
                $scope.load = false;
            });




            $scope.loadKendo = function () {
                $scope.KendoGridSource = new kendo.data.DataSource({
                    transport: {
                        read: function (o) {

                            o.data.CustomerId = $scope.filter.CustomerId;
                            o.data.Priority = $scope.filter.Priority;
                            o.data.StatusId = $scope.filter.StatusId;
                            o.data.DeveloperId = $scope.filter.DeveloperId;
                            o.data.CustomerIds = $scope.filter.CustomerIds;
                            o.data.Code = $scope.CompanyProfile.CustomerCode;

                            MainService.TicketsInView(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success(false);
                                toastr.error($scope.NetworkErrorLan);
                            })
                        }
                    },
                    change: function (data) {},
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Date: {
                                    type: "date",
                                },
                                RefNo: {
                                    type: "string",
                                },

                                "Customer.Name": {
                                    type: "string",
                                },

                                Priority: {
                                    type: "string",
                                },

                                "SupportCategory.Name": {
                                    type: "string",
                                },
                                Subject: {
                                    type: "string",
                                },
                                "Status.Name": {
                                    type: "string",
                                },




                            }
                        }
                    },
                    pageSize: 30,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                });

                $scope.KendoGridOptions = {
                    toolbar: ["excel"],
                    stretch: true,
                    selectable: true,
                    groupable: false,
                    height: 650,
                    sortable: true,
                    resizable: true,
                    dataSource: $scope.KendoGridSource,
                    pageable: true,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    filterable: true,

                    columns: [
                        {
                            field: "RefNo",
                            title: "#",
                            width: "100px"
                    },
                        {
                            field: "Date",
                            template: "<p> {{dataItem.Date | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Date",
                            width: "100px"
                    },
//                        {
//                            field: "Customer.Name",
//                            title: "Customer",
//                    },
                        {
                            field: "Subject",
                            title: "Subject",
                    },
                        {
                            field: "Priority",
                            title: "Priority",
                            width: "100px"
                    },
                        {
                            field: "SupportCategory.Name",
                            title: "Category",
                            width: "170px"
                    },
//                        {
//                            field: "Developer.Name",
//                            title: "Developer",
//                            width: "150px"
//                    },
                        {
                            field: "Status.Name",
                            title: "Status",
                            template: '<button ng-if="dataItem.Status.Name == \'Rejected\'" class="btn btn-warning btn-sm">Rejected</button>                                        <button ng-if="dataItem.Status.Name == \'Finished\'" class="btn btn-success btn-sm">Finished</button>                                        <button ng-if="dataItem.Status.Name == \'Processing\'" class="btn btn-info btn-sm">Processing</button>                                        <button ng-if="dataItem.Status.Name == \'Approved\'" class="btn btn-primary btn-sm">Approved</button>                                        <button ng-if="dataItem.Status.Name == \'Pending\'" class="btn btn-danger btn-sm">Pending</button>',
                            width: "100px"
                    },
                        {
                            title: "Options",
                            template: "<button class=' btn-default btn-sm fa fa-eye'  ng-click='View(dataItem)'>  </button> ",
                            width: "70px"
                        },
                                        ],
                };

            }

            $scope.Init = function () {

                $scope.TicketList = [];
                $scope.CompanyProfile = {};

                $scope.filter = {
                    Code: "",
                    CustomerId: "",
                    Priority: "",
                    StatusId: "",
                    DeveloperId: "",
                }

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                    $scope.loadKendo();
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });


            }
            $scope.Init();

            $scope.refresh = function () {
                $scope.Init();
                $scope.filter = {
                    Code: "",
                    CustomerId: "",
                    Priority: "",
                    StatusId: "",
                    DeveloperId: "",
                }
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.View = function (data) {
                //                $state.go("ViewTicket", {
                //                    VoucherId: data.Id
                //                });

                var url = $state.href('ViewTicket', {
                    VoucherId: data.Id
                });
                $window.open(url, '_blank');

            }


                }])
